const getDefaultState = () => {
  return {
    votingLimitRules: {
      totalTantiemesGenerales: null,
      // INFO: pouvoirs
      votingLimitIsActive: false,
      votingLimitOperator: null,
      votingIncludesMandate: false,
      votesLimitPerMandate: null,
      tantiemesLimitPerMandate: null,
      // INFO: plafon majority
      plafonMajorityIsActive: false,
      plafonMajorityTantiemes: null,
      totalTantiemesGeneralesPlafonMajority: null,
      plafonMajorityText: null,
      // INFO: article 22
      article22IsActive: false,
      buildingOwnerIdArticle22: null,
      reducedMandateTantiemesArticle22: null,
      totalTantiemesGeneralesArticle22: null,
    },
  };
};

export default {
  namespaced: true,
  state: getDefaultState(), // initial state
  mutations: {
    resetState(state) {
      // Merge rather than replace so we don't lose observers
      Object.assign(state, getDefaultState());
    },

    setFreezedVotingLimitRules(state, payload) {
      // payload is meeting "general-details" event (get needed data..)
      state.votingLimitRules = {
        ...state.votingLimitRules,

        totalTantiemesGenerales: payload.totalTantiemesGenerales,

        votingLimitIsActive: payload.votingLimitIsActive,
        votingLimitOperator: payload.votingLimitOperator,
        votingIncludesMandate: payload.votingIncludesMandate,
        votesLimitPerMandate: payload.votesLimitPerMandate,
        tantiemesLimitPerMandate: payload.tantiemesLimitPerMandate,

        plafonMajorityIsActive: payload.plafonMajorityIsActive,
        plafonMajorityTantiemes: payload.plafonMajorityTantiemes,
        totalTantiemesGeneralesPlafonMajority: payload.totalTantiemesGeneralesPlafonMajority,
        plafonMajorityText: payload.plafonMajorityText,

        article22IsActive: payload.article22IsActive,
        buildingOwnerIdArticle22: payload.buildingOwnerIdArticle22,
        reducedMandateTantiemesArticle22: payload.reducedMandateTantiemesArticle22,
        totalTantiemesGeneralesArticle22: payload.totalTantiemesGeneralesArticle22,
      };
    },

    setTotalTantiemesGenerales(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, totalTantiemesGenerales: payload };
    },

    setVotingLimitIsActive(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, votingLimitIsActive: payload };
    },
    setVotingLimitOperator(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, votingLimitOperator: payload };
    },
    setVotingIncludesMandate(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, votingIncludesMandate: payload };
    },
    setVotesLimitPerMandate(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, votesLimitPerMandate: payload };
    },
    setTantiemesLimitPerMandate(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, tantiemesLimitPerMandate: payload };
    },

    setPlafonMajorityIsActive(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, plafonMajorityIsActive: payload };
    },
    setPlafonMajorityTantiemes(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, plafonMajorityTantiemes: payload };
    },
    setTotalTantiemesGeneralesPlafonMajority(state, payload) {
      state.votingLimitRules = {
        ...state.votingLimitRules,
        totalTantiemesGeneralesPlafonMajority: payload,
      };
    },
    setPlafonMajorityText(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, plafonMajorityText: payload };
    },

    setArticle22IsActive(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, article22IsActive: payload };
    },
    setBuildingOwnerIdArticle22(state, payload) {
      state.votingLimitRules = { ...state.votingLimitRules, buildingOwnerIdArticle22: payload };
    },
    setReducedMandateTantiemesArticle22(state, payload) {
      state.votingLimitRules = {
        ...state.votingLimitRules,
        reducedMandateTantiemesArticle22: payload,
      };
    },
    setTotalTantiemesGeneralesArticle22(state, payload) {
      state.votingLimitRules = {
        ...state.votingLimitRules,
        totalTantiemesGeneralesArticle22: payload,
      };
    },
  },
};
